export enum PatientRouteParamsEnum {
  PATIENT_ID = 'patientId',
}
